import React, { FC, useState, useEffect } from "react"
import _ from "lodash"
import { RouteComponentProps } from "@reach/router"
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

const LineItemsWrapper: FC<RouteComponentProps> = (props) => {
  const [tabs, setTabs] = useState<Array<{name: string, link: string}> | []>([])

  useEffect(() => {
    let tab_list = [
      {name: "All", link: "/n/line-items/all", hard: false},
      {name: "Misc Income", link: "/n/line-items/misc-income", hard: false},
      {name: "Expense", link: "/n/line-items/expense", hard: false},
      {name: "Expense: Non-Recov", link: "/n/line-items/non-recoverable-expense", hard: false},
      {name: "Building Capital", link: "/n/line-items/building-capital", hard: false}
    ]

    setTabs(tab_list)
  }, [])

  return (
    <Container_s>
      <Subnav section="LINE ITEMS" tabs={tabs}/>
      <div style={{paddingTop: '72px'}}>
        { props.children }
      </div>
    </Container_s>
  )
}

export default LineItemsWrapper
